import Moment from "moment-timezone";

let defaultTZ = process.env.REACT_APP_DEFAULT_TZ ;
const storedTZ = localStorage.getItem("UserTimeZone");
  if (storedTZ && storedTZ !== "null" && storedTZ !== "") {
    defaultTZ = storedTZ;
  }


const UserMoment = Moment.tz.setDefault(defaultTZ);

export const updateTimeZone = (timezone) => {
  if (timezone) Moment.tz.setDefault(timezone);
};
export default UserMoment;
